'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _extName = require('ext-name');

var _extName2 = _interopRequireDefault(_extName);

var _video = require('video.js');

var _video2 = _interopRequireDefault(_video);

require('videojs-youtube');

var _player = require('@vimeo/player');

var _player2 = _interopRequireDefault(_player);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var propTypes = {
	class: {
		type: 'string'
	},
	autoplay: {
		type: 'boolean'
	},
	controls: {
		type: 'boolean'
	},
	loop: {
		type: 'boolean'
	},
	muted: {
		type: 'boolean'
	},
	poster: {
		type: 'string'
	},
	preload: {
		type: 'string'
	},
	aspectRatio: {
		type: 'string'
	},
	source: {
		type: 'string'
	}
};

var defaultProps = {
	poster: '',
	preload: 'auto',
	aspectRatio: '16:9'
};

var getAspectRatio = function getAspectRatio(aspectRatio) {
	var regex = /^\d{1,}:\d{1,}$/;

	if (!regex.test(aspectRatio)) {
		return '16:9';
	}

	return aspectRatio;
};

var getVideo = function getVideo(id, props) {
	var autoplay = props.autoplay,
	    controls = props.controls,
	    loop = props.loop,
	    muted = props.muted,
	    poster = props.poster,
	    source = props.source;

	var file = (0, _extName2.default)(source);

	if (file && (file.mime === 'video/mp4' || file.mime === 'video/webm' || file.mime === 'video/ogg')) {
		var nonTypeFileName = source.slice(0, -(file.ext.length + 1));
		var options = {
			fluid: true,
			aspectRatio: getAspectRatio(props.aspectRatio)
		};

		return (0, _magicVirtualElement2.default)(
			'video',
			{ 'class': 'vjs-viskan video-js', id: 'deku-video-' + id, 'data-setup': JSON.stringify(options), autoplay: autoplay, controls: controls, loop: loop, muted: muted, playsInline: true, poster: poster },
			(0, _magicVirtualElement2.default)('source', { src: nonTypeFileName + '.mp4', type: 'video/mp4' }),
			(0, _magicVirtualElement2.default)('source', { src: nonTypeFileName + '.webm', type: 'video/webm' }),
			(0, _magicVirtualElement2.default)('source', { src: nonTypeFileName + '.ogg', type: 'video/ogg' })
		);
	}

	if (source.includes('youtube.com')) {
		var _options = {
			fluid: true,
			aspectRatio: getAspectRatio(props.aspectRatio),
			nativeControlsForTouch: true,
			techOrder: ['youtube'],
			sources: [{
				src: source,
				type: 'video/youtube'
			}],
			youtube: {
				ytControls: 2,
				customVars: {
					showinfo: 1,
					playsinline: 1
				}
			}
		};

		return (0, _magicVirtualElement2.default)('video', { 'class': 'vjs-viskan vjs-viskan-youtube video-js', id: 'deku-video-' + id, 'data-setup': JSON.stringify(_options), autoplay: autoplay, controls: controls, loop: loop, muted: muted, playsInline: true, poster: poster });
	}

	if (source.includes('vimeo.com')) {
		return (0, _magicVirtualElement2.default)('div', { id: 'deku-video-' + id, 'data-vimeo-url': source, 'data-vimeo-width': '100%', 'data-vimeo-responsive': '1', 'data-vimeo-color': 'fbc51b', 'data-vimeo-autoplay': props.autoplay, 'data-vimeo-loop': props.loop });
	}

	return (0, _magicVirtualElement2.default)('noscript', null);
};

var afterMount = function afterMount(_ref, el, setState) {
	var id = _ref.id,
	    props = _ref.props;
	var source = props.source;


	if (source) {
		if (source.includes('vimeo.com')) {
			var vimeoPlayer = new _player2.default('deku-video-' + id);
			setState({ player: null, vimeoPlayer: vimeoPlayer });
		} else {
			var player = (0, _video2.default)('#deku-video-' + id);
			setState({ player: player, vimeoPlayer: null });
		}
	}
};

var afterUpdate = function afterUpdate(_ref2, prevProps, prevState, setState) {
	var id = _ref2.id,
	    props = _ref2.props,
	    state = _ref2.state;
	var source = props.source;


	if (source) {
		if (source.includes('vimeo.com')) {
			var vimeoPlayer = new _player2.default('deku-video-' + id);
			setState({ player: null, vimeoPlayer: vimeoPlayer });
		} else {
			var player = (0, _video2.default)('#deku-video-' + id);
			setState({ player: player, vimeoPlayer: null });
		}
	}
};

var beforeUpdate = function beforeUpdate(_ref3, nextProps) {
	var id = _ref3.id,
	    props = _ref3.props,
	    state = _ref3.state;
	var player = state.player,
	    vimeoPlayer = state.vimeoPlayer;


	if ((0, _deepEqual2.default)(props, nextProps)) {
		return;
	}

	if (player) {
		player.dispose();
	}

	if (vimeoPlayer) {
		vimeoPlayer.unload();
	}
};

var beforeUnmount = function beforeUnmount(_ref4) {
	var state = _ref4.state;
	var player = state.player,
	    vimeoPlayer = state.vimeoPlayer;


	if (player) {
		player.dispose();
	}

	if (vimeoPlayer) {
		vimeoPlayer.unload();
	}
};

var shouldUpdate = function shouldUpdate(_ref5, nextProps) {
	var props = _ref5.props;
	return !(0, _deepEqual2.default)(props, nextProps);
};

var render = function render(_ref6) {
	var id = _ref6.id,
	    props = _ref6.props;

	var date = new Date().getTime();

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['DekuVideo', props.class, props.styleClasses && props.styleClasses.Video], 'data-style-attr': 'Video' },
		(0, _magicVirtualElement2.default)(
			'div',
			{ key: date, 'data-vjs-player': true },
			getVideo(id, props)
		)
	);
};

exports.default = { afterMount: afterMount, afterUpdate: afterUpdate, beforeUpdate: beforeUpdate, beforeUnmount: beforeUnmount, defaultProps: defaultProps, propTypes: propTypes, render: render, shouldUpdate: shouldUpdate };